/* @flow */

export default class CompanyDocumentFilters {
  documentTypeIds: number[];

  constructor() {
    this.documentTypeIds = [];
  }
}
